import React from 'react';
import { ListItemText } from '@mui/material';

import { HEALTH_CATEGORIES } from '@shared/forms';

import { useAuth } from '../../../hooks';
import { Accordion } from './Accordion';
import { NavigationLink } from './NavigationLink';

export const CatalogueMenuItems = ({ onClose }) => {
  const { catalogues } = useAuth();

  /**
   * @param {import('@shared/forms/index.js').HealthCategory} catalogue
   */
  const getCatalogText = (catalogue) => {
    if (catalogue === HEALTH_CATEGORIES.MEDICINAL_CANNABIS) {
      return 'Alternative Therapies';
    }

    return catalogue;
  };

  const handleOnClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  if (catalogues?.length === 0) {
    return null;
  }

  return (
    <Accordion>
      <Accordion.Trigger title="Catalogue" to="/catalogue" onClick={handleOnClick} />

      <Accordion.Details>
        {catalogues.map((catalogue) => (
          <NavigationLink key={catalogue} to={`/catalogue/${catalogue}`} onClose={onClose}>
            <ListItemText
              style={{ paddingLeft: 20, textTransform: 'capitalize' }}
              primary={getCatalogText(catalogue)}
            />
          </NavigationLink>
        ))}
      </Accordion.Details>
    </Accordion>
  );
};
